import ConnectWallet from "./connect-wallet";

export default ConnectWallet;
